import isEmail from 'validator/lib/isEmail';
import { isValidBirthday } from './isValidBirthday';

export const isValidInsuranceNumber = (val: string) => new RegExp('[a-zA-Z]{1}\\d{9}$', 'i').test(val);
export const isValidEmail = (val: string) => !val || isEmail(val);
export const isValidBirthDate = (val: string) => !val || isValidBirthday(val);
